<template>
	<div>
		<div v-if="$store.subscription && $store.subscription.plan_level > 0" class="text-center alert alert-success">
			
			<h3 class="m-0">You are subscribed!</h3>

		</div>
		<div v-else>

			<widget class="mt-2">
				<h3>All Paid Plans Include:</h3>

				<ul>
					<li>Full feature set</li>
					<li>Upgrade any time</li>
					<li>No committment</li>
				</ul>

				<h3>Free Tier Includes:</h3>

				<ul>
					<li>Time tracking and basic project management only</li>
					<li>Upgrade any time</li>
				</ul>
			</widget>

			<div class="card mb-3" :class="{}"
				v-for="(plan,index) in plans">

				<h3 class="card-header text-white" :style="{backgroundColor: planColors[index]}">
					{{ plan.name }}
				</h3>

				<div class="card-body">
					<div class="d-flex justify-content-between align-items-center">
						<div>
							Good for a company of up to {{mutateUpto(plan.user_limit)}} people
						</div>
						<div>
							<div v-if="plan.stripe_plan_id == value" class="text-success">
								<i class="far fa-check-square"></i>
								Selected
							</div>
							<button v-else class="btn btn-light" type="button" v-on:click="selectPlan(plan.stripe_plan_id)">
								Select
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"

export default {
	name: "SubscriptionChoices",
	components: {
		Widget
	},
	props: [
		"redirectThankyouCustom",
		"redirectErrorCustom",
		'value',
	],
	watch: {
		redirectErrorCustom() {
			this.redirectError = this.redirectErrorCustom
		},
		redirectThankyouCustom() {
			this.redirectThankyou = this.redirectThankyouCustom
		}
	},
	data() {
		return {
			redirectThankyou: "https://"+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/settings/tradetraks-subscription",
			redirectError: "https://"+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/settings/tradetraks-subscription/error",
			fetchDone: false,
			plans: [],
			environment: window.environment
		}
	},
	computed: {
		planColors() {
			let red = 186, green = 170, blue = 255
			let colors = []

			for (var i = 0; i < this.plans.length; i++) {
				red *= 0.9
				green *= 0.9
				blue *= 0.95

				colors.push("rgb("+red+","+green+","+blue+")")
			}

			return colors
		},

	},
	methods: {
		setPlan() {
			let cart = []
			try {
				cart = JSON.parse(localStorage.getItem("cart"))
			}
			catch (e) {}

			let planId

			if (cart) {
				planId =  cart.find(item => item.search("plan_") >= 0)
				if (planId)
					this.selectPlan(planId)
			}
		},
		selectPlan(plan_id) {

			let vm = this
			let localStorageCart = new Set() //use a set to handle removal of duplicates

			try {
				let cartFromLocalStorage = localStorage.getItem("cart")

				if (cartFromLocalStorage)
					localStorageCart = new Set(JSON.parse(cartFromLocalStorage))
			}
			catch (e) {}

			//remove any other plan in cart
			localStorageCart.clear()

			localStorageCart.add(plan_id)

			localStorage.setItem('cart',JSON.stringify([...localStorageCart]))

			let plan = this.plans.find(thePlan => thePlan.stripe_plan_id == plan_id)

			if (plan && plan.isFree)
				localStorage.setItem('planIsFree',true)
			else
				localStorage.setItem('planIsFree',false)

			this.$forceUpdate()

			this.$emit('input',plan_id)
		},
		mutateUpto(upto) {
			if (upto > 998)
				return "unlimited"
			else
				return upto
		},
		fetchPlans() {
			let vm = this

			this.getJSON("Subscription/plans").then(response => {
				if (response.success)
					vm.plans = response.data
			})
		},
		fetchCurrentSubscription() {
			let vm = this

			this.getJSON("Subscription/get",{},true).then(response => {
				if (response.success && response.data.length > 0) 
					vm.$store.subscription = response.data[0]
			})
		},
	},
	created() {
		this.fetchPlans()
		this.fetchCurrentSubscription()

		this.setPlan()

		this.setSessionToken() //reports from support personnel that Subscription/create?token= endpoint is throwing "Token or Api key not valid" error, so make sure we're working with a fresh security token

		if (this.redirectThankyouCustom)
			this.redirectThankyou = this.redirectThankyouCustom

		if (this.redirectErrorCustom)
			this.redirectError = this.redirectErrorCustom

		if ("error_message" in this.$route.params) {
			this.errorModal.visible = true
			this.errorModal.message = this.$route.params.error_message
		}
	}
}
</script>
